<template>
    <div class="learn-record-c">
        <h3>{{$route.query.name}}，在线学习共 {{values.length&&values.reduce((a,b)=>a+b)}} 分钟</h3>
        <div ref="recordCharts" style="width: 100%;height: calc(100vh - 200px)"></div>
    </div>
</template>

<script scoped>
    export default {
        name: "LearnRecordCharts",
        data() {
            return {
                apiUrl: process.env.VUE_APP_URL + "ma/LearnRecord/",
                x: [],
                y: [],
                values: [],
                list: []
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.$axios.get(
                    this.apiUrl + "getRecord?openId=" + this.$route.query.id
                ).then(({data}) => {
                    if (data.code === 200) {
                        let chartsData = JSON.parse(data.message);
                        chartsData.forEach(item => {
                            if (this.x.indexOf(item.courseName) < 0) this.x.push(item.courseName);
                            if (this.y.indexOf(item.day) < 0) this.y.push(item.day);
                            let m = Math.ceil(item.learnCount / 60);
                            this.values.push(m);
                            this.list.push([this.y.indexOf(item.day), this.x.indexOf(item.courseName), m]);
                        });
                        this.x.length && this.y.length && this.list.length && this.initRecord();
                    } else {
                        this.$message.error('数据获取失败');
                    }
                });
            });
        },
        methods: {
            initRecord() {
                let dom = this.$refs['recordCharts'];
                let recordCharts = echarts.init(dom);
                let app = {};
                let option = null;
                let x = this.x;
                let y = this.y;
                let data = this.list;
                data = data.map(function (item) {
                    return [item[1], item[0], item[2] || '-'];
                });

                option = {
                    tooltip: {
                        position: 'bottom',
                        formatter(data) {
                            return `# ${data.name} #<br />${y[data.data[1]]}<br />在线学习（${data.data[2]}）分钟`;
                        }
                    },
                    animation: false,
                    grid: {
                        height: '60%',
                        left: '9%',
                        right: '5%',
                        top: '5%'
                    },
                    xAxis: {
                        type: 'category',
                        data: x,
                        axisLabel: {
                            // interval: 0,//0:显示所有标签，n:间隔n个标签显示
                            rotate: 90
                        },
                        splitArea: {
                            show: true
                        }
                    },
                    yAxis: {
                        type: 'category',
                        data: y,
                        splitArea: {
                            show: true
                        }
                    },
                    visualMap: {
                        min: 0,
                        max: Math.max.apply(Math, this.values),
                        calculable: true,
                        orient: 'horizontal',
                        left: 'center',
                        bottom: '1%'
                    },
                    series: [{
                        name: '在线学习时长（分钟）',
                        type: 'heatmap',
                        data: data,
                        label: {
                            show: true
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }]
                };
                if (option && typeof option === "object") {
                    recordCharts.setOption(option, true);
                }
            }
        }
    }
</script>

<style scoped>
    .learn-record-c {
        margin: 20px;
        /*text-align: right;*/
    }

    .learn-record-c h3 {
        text-align: center;
        color: #4f4f4f;
    }
</style>